import { fabric } from 'fabric';
import apis from '@/apis';

import {
  normalizeObjectPropsFromPropsEditor,
  getShadow,
  findTopText,
  getGroupingObjects,
  isJCKLanguage,
  getCORSImageUrl,
  scroll2object,
  normalizeObjectProps4PropsEditor,
  transformEditorProps4canvas,
  getGradientColor,
  preloadFont,
  getRecordState,
  isBase64,
} from '@/utils';
import { cloneDeep, pickBy, findLastIndex } from 'lodash-es';
import { groupSupportKey, groupSupportProps } from '@/components/PropsEditor/schemas/group';
import { getEditorDataByRequestIdRemote } from '@/utils/ls';
import { setImageObject } from './setObject';
import { message } from 'ant-design-vue';

export const replaceState = ({ commit }, payload) => {
  commit('REPLACE_STATE', payload);
  // 如果当前激活的object已经不存在了，则失活，否则还是保持激活的状态
  // if (!state.objectMap[state.selectedObjectUid]) {
  //   commit('DISCARD_ACTIVE_OBJECT');
  // }
  commit('SET_SELECTED_OBJECT_UID', -1);
  $XJCanvas.discardActiveObject();
};

export const discardActiveObject = context => {
  const { commit, state } = context;
  if (state.isGrouping) {
    // const { objectPropsMap, objectUIDs } = state;
    // renderAll(context, { objectPropsMap, objectUIDs });
  }
  commit('DISCARD_ACTIVE_OBJECT');
  setGroupState(context, false);
};

export const setGroupState = ({ commit }, grouping) => {
  commit('SET_STATE', {
    isGrouping: grouping,
    groupUids: grouping ? $XJCanvas.getActiveObjects().map(i => i.$$uid) : [],
  });
};

export const setCurrentPropsEditorType = (context, payload) => {
  context.commit('SET_STATE', {
    currentPropsEditorType: payload,
  });
};

export const getTranslateResult = (context, payload) => {
  // reset state
  const { commit, state, rootGetters } = context;

  /**
   *
   * todo: 后续流程都需要改变 从url加载图片，而不是从api获取图片， 只有调用AI Assisant 中翻译才会调用api获取图片
   */
  // 空白图片快速检测 - 跳过API调用
  const { RequestId } = payload;
  if (RequestId?.includes('blank')) {
    console.log('=== [空白图片跳过模式] 跳过API调用，直接初始化 ===');

    context.commit('RESET_UID');
    commit('SET_EDITOR_LOADING', true);
    commit('SET_LOAD_DATA_ERROR', false);

    // 空白图片基本元数据（与普通图片兼容）
    const blankMeta = {
      HasWatermark: false,
      WatermarkLayerSslUrl: '',
      WatermarkLayerUrl: '',
      Orc: '',
      TargetLanguage: '',
      SourceLanguage: '',
    };

    // 设置空白图片的基本状态
    commit('SET_STATE', {
      targetLanguage: '',
      sourceLanguage: '',
    });

    // ✅ 获取当前空白图片的dataURL数据
    const currentImage = context.rootState.multi.editImageList.find(img => img.requestId === RequestId);
    const blankImageOriginUrl = currentImage ? currentImage.OriginUrl : '';

    // 构建空白图片的模拟响应数据（包含正确的URL）
    const blankResponse = {
      Data: {
        ...blankMeta,
        OriginUrl: blankImageOriginUrl,
        SslRmUrl: blankImageOriginUrl,
        RmUrl: blankImageOriginUrl,
      },
      Success: true,
    };

    // 直接处理空白图片的"模拟响应"
    return Promise.resolve(blankResponse).then(async res => {
      console.log('=== [空白图片] 使用快速模拟数据 ===', res);

      const { HasWatermark, WatermarkLayerSslUrl, WatermarkLayerUrl } = res.Data;
      const storage = await getEditorDataByRequestIdRemote(context.rootState.multi.requestId);

      let objectUIDs = [];
      let objectPropsMap = {};
      let FROM_STORAGE = false;
      let cropInfo = {};

      // 空白图片：无缓存，直接创建空状态
      if (storage && storage.objectUIDs && storage.objectPropsMap) {
        console.log('=== [空白图片] 使用缓存数据 ===');
        objectUIDs = storage.objectUIDs;
        objectPropsMap = storage.objectPropsMap;
        FROM_STORAGE = true;
        cropInfo = storage.cropInfo || {};
      }

      // 设置编辑器元数据
      const $WatermarkLayerUrl = WatermarkLayerSslUrl || WatermarkLayerUrl || '';
      commit('SET_EDITOR_METADATA', {
        OriginUrlRemote: res.Data.OriginUrl,
        OriginUrl: res.Data.OriginUrl,
        RmUrl: res.Data.RmUrl,
        WatermarkLayerUrl: $WatermarkLayerUrl,
        HasWatermark: !!HasWatermark,
      });

      if (FROM_STORAGE) {
        commit('SET_STATE', {
          objectPropsMap,
          objectUIDs,
          cropInfo,
          FROM_STORAGE: true,
        });
        return { objectPropsMap, objectUIDs, cropInfo, FROM_STORAGE };
      }

      // 空白图片：默认无OCR对象，直接返回空状态
      console.log('=== [空白图片] 使用空状态初始化 ===');
      return {
        objectPropsMap: {},
        objectUIDs: [],
        cropInfo: {},
        FROM_STORAGE: false,
        isBlank: true, // 特殊标识
        WatermarkLayerUrl: $WatermarkLayerUrl,
        HasWatermark: !!HasWatermark,
      };
    });
  }

  // 普通图片流程维持不变
  context.commit('RESET_UID');
  commit('SET_EDITOR_LOADING', true);
  commit('SET_LOAD_DATA_ERROR', false);
  return apis.app
    .getImageTranslate(payload)
    .then(async res => {
      const { HasWatermark, WatermarkLayerSslUrl, WatermarkLayerUrl, Orc, TargetLanguage, SourceLanguage } = res.Data;
      const isJCK = isJCKLanguage(TargetLanguage);
      commit('SET_STATE', { targetLanguage: TargetLanguage, sourceLanguage: SourceLanguage });
      const storage = await getEditorDataByRequestIdRemote(context.rootState.multi.requestId);
      console.log('firstRender', storage);
      // 在每次存储的时候新增了一个requestId，如果有该字段就比对，没有就放过
      const isMatch = storage?.requestId ? storage?.requestId === context.rootState.multi.requestId : true;
      let objectUIDs = [];
      let objectPropsMap = {};
      let FROM_STORAGE = false;
      let cropInfo = {};
      // 请求回来之后，如果有缓存就用缓存，这里之所以请求一次，后面有可能需要用到还原原始图片翻译结果
      if (storage && storage.objectUIDs && storage.objectPropsMap && isMatch) {
        objectUIDs = storage.objectUIDs;
        cropInfo = storage.cropInfo || {};
        objectPropsMap = storage.objectPropsMap;
        Object.keys(objectPropsMap).forEach(uid => {
          const item = objectPropsMap[uid];
          // 渐变色设置相关属性
          item.fgType = item.fgType || 'pure';
          item.fgGradientDirection = item.fgGradientDirection || 'v';
          item.fgGradientStart = item.fgGradientStart || item.fg;
          item.fgGradientEnd = item.fgGradientEnd || item.fg;
        });
        const fonts = Object.keys(objectPropsMap).map(key => objectPropsMap[key].fontFamily);
        console.log('fonts from storage', fonts);
        await preloadFont(fonts, rootGetters['user/customFontMap']);
        commit('SET_UID', Math.max(...objectUIDs));
        if (storage.manualSortedUids) {
          commit('SET_MANUAL_SORTED_UIDS', storage.manualSortedUids);
        }
        FROM_STORAGE = true;
      } else {
        objectUIDs = [];
        objectPropsMap = Orc.reduce((map, item) => {
          // 垂直文本去除空格，因为空格因为行高影响导致垂直文字中的空格显得特别大
          // 不知道将来有没有坑
          try {
            if (item.orientation === 'v' && isJCK) {
              item.target = item.target.replace(/\s/g, '');
            }
          } catch (err) {}
          commit('INCREASE_UID');
          const uid = state.uid;
          // 渐变色设置相关属性
          item.fgType = 'pure';
          item.fgGradientDirection = 'v';
          item.fgGradientStart = item.fg;
          item.fgGradientEnd = item.fg;
          map[uid] = item;
          objectUIDs.push(uid);
          return map;
        }, {});
        const fonts = Object.keys(objectPropsMap).map(key => objectPropsMap[key].fontFamily);
        console.log('fonts from remote', fonts);
        await preloadFont(fonts);
      }

      const $WatermarkLayerUrl = HasWatermark ? getCORSImageUrl(WatermarkLayerSslUrl || WatermarkLayerUrl) : '';

      commit('SET_EDITOR_METADATA', {
        ...res.Data,
        HasWatermark,
        OriginUrlRemote: res.Data.OriginUrl,
        OriginUrl: storage?.OriginUrl || res.Data.OriginUrl,
        SslRmUrl: storage?.RmUrl || res.Data.SslRmUrl || res.Data.RmUrl,
        WatermarkLayerUrl: $WatermarkLayerUrl,
      });
      return {
        objectPropsMap,
        objectUIDs,
        cropInfo,
        FROM_STORAGE,
        WatermarkLayerUrl: $WatermarkLayerUrl,
      };
    })
    .catch(err => {
      commit('SET_LOAD_DATA_ERROR', err);
      commit('SET_EDITOR_LOADING', false);
    });
};

// 一个记录点
// 删除object
export const deleteSelectedObject = context => {
  const { commit, dispatch, state } = context;
  const selectedObject = $XJCanvas.getActiveObject();
  $XJCanvas.remove(selectedObject);
  commit('REMOVE_SELECTED_OBJECT');
  $XJCanvas.requestRenderAll();
  dispatch('record/addState', getRecordState(state), { root: true });
};

// 一个记录点
// 删除组里的所有object
export const deleteGroupObject = context => {
  const { commit, dispatch, state } = context;
  const { objects } = getGroupingObjects();
  objects.forEach(object => {
    $XJCanvas.remove(object);
    commit('REMOVE_OBJECT_BY_UID', object.$$uid);
  });
  $XJCanvas.requestRenderAll();
  dispatch('setGroupState', false);
  dispatch('record/addState', getRecordState(state), { root: true });
};

// 一个记录点
// 从属性编辑器更新object属性
export const updateSelectedObjectFromPropsEditor = ({ getters, dispatch, state }) => {
  let options = normalizeObjectPropsFromPropsEditor(getters['selectedObjectProps']);
  const selectedObject = getters['selectedObject'];
  console.log(6766767, options);
  // 如果当前选中的object在group里的话，不要重新set，这时的left/top是相对group的，所以set原来的值会出现偏移
  if (state.isGrouping) {
    return;
  }
  if (selectedObject) {
    if (selectedObject.type === 'image' && selectedObject.$$isCancelTranslated) {
      selectedObject.set({ ...options, cropX: options.left, cropY: options.top });
    } else {
      selectedObject.set(options);
    }
  }
  $XJCanvas.requestRenderAll();
  dispatch('record/addState', getRecordState(state), { root: true });
};

// 一个记录点
// 从属性编辑器更新object属性
export const updateGroupTextCase = ({ commit, dispatch, state }, payload = {}) => {
  const { transformer } = payload;
  $XJCanvas.getActiveObjects().forEach(obj => {
    const uid = obj.$$uid;
    const target = transformer(state.objectPropsMap[uid].target);
    commit('UPDATE_OBJECT_PROPS', { uid, props: { target } });
    obj.set({ text: target });
  });
  $XJCanvas.requestRenderAll();
  dispatch('record/addState', getRecordState(state), { root: true });
};

// 一个记录点
// 从键盘快捷键更新object属性
export const updateSelectedObjectFromPropsKeyboard = ({ commit, getters, state, dispatch }, payload) => {
  commit('UPDATE_SELECTED_OBJECT_PROPS', {
    ...getters['selectedObjectProps'],
    ...payload,
  });
  dispatch('record/addState', getRecordState(state), { root: true });
};

// 一个记录点
// 从canvas更新object属性
export const updateSelectedObjectFromCanvas = ({ commit, getters, state, dispatch }, payload) => {
  commit('UPDATE_SELECTED_OBJECT_PROPS', {
    ...getters['selectedObjectProps'],
    ...payload,
  });
  dispatch('record/addState', getRecordState(state), { root: true });
};

// 一个记录点
// 更新组里的元素属性
export const updateGroupingObjectFormCanvas = ({ state, dispatch, commit }, groupingState) => {
  const { objects, group } = groupingState;
  const { scaleX } = group;
  objects.forEach(object => {
    const { left, top, $$uid, fontSize, width } = object;
    const point = new fabric.Point(left, top);
    const transform = group.calcTransformMatrix();
    const actualCoordinates = fabric.util.transformPoint(point, transform);

    console.log('UPDATE_OBJECT_PROPS', actualCoordinates, object, scaleX);
    commit('UPDATE_OBJECT_PROPS', {
      uid: $$uid,
      props: {
        left: actualCoordinates.x,
        top: actualCoordinates.y,
        zoomX: 1,
        zoomY: 1,
        width: width * scaleX,
        fontSize: scaleX * fontSize,
      },
    });
  });
  dispatch('record/addState', getRecordState(state), { root: true });
};

// 一个记录点
// 从属性编辑器批量更新object
// groupSupportKey,groupSupportProps
export const updateGroupingObjectFromPropsEditor = ({ state, dispatch, commit }, payload) => {
  console.log('updateGroupingObjectFromPropsEditor 1', { ...payload });
  const payload4object = transformEditorProps4canvas(payload);
  const result = pickBy(payload4object, (value, key) => {
    return groupSupportKey.indexOf(key) > -1 && groupSupportProps[key]?.validate(value);
  });
  if (payload.fontSize === '' || payload.fontSize === undefined) delete payload.fontSize;
  if (payload.fg === -1) delete payload.fg;
  if (payload.backgroundColor === -1) delete payload.backgroundColor;
  if (payload.textAlign === -1) delete payload.textAlign;
  if (payload.lineHeight === -1) delete payload.lineHeight;
  ['fgType', 'fgGradientDirection', 'fgGradientDirection', 'fgGradientStart', 'fgGradientEnd'].forEach(i => {
    if (payload[i] === undefined) delete payload[i];
  });
  console.log('updateGroupingObjectFromPropsEditor 2', { payload4object, result, payload });
  const { objects } = getGroupingObjects();

  // console.log(88888888888, { objects });
  objects.forEach(object => {
    let fill = '';
    if (result.fgType === 'pure') {
      fill = result.fill;
    }
    // 渐变色的几个属性都存在的时候才行，否则不设置
    if (result.fgType === 'gradient' && result.fgGradientEnd && result.fgGradientStart && result.fgGradientDirection) {
      fill = getGradientColor({ ...result, width: object.width, height: object.height });
    }

    // console.log(88888888888, { fill, result: JSON.stringify(result) });
    // 不用原fill
    const { fill: _fill, textAlign = '', ...restResult } = result;
    object.set({
      ...restResult,
      // 单独设置前景色渐变，渐变根据每个文本的宽高而定，需每个文本单独处理
      ...(fill ? { fill } : {}),
      // fix: textAlign.indexOf报错的问题(textAlign为undefined)
      textAlign,
    });
    commit('UPDATE_OBJECT_PROPS', {
      uid: object.$$uid,
      props: normalizeObjectProps4PropsEditor(result, object),
    });
  });
  $XJCanvas.requestRenderAll();
  dispatch('record/addState', getRecordState(state), { root: true });
};

export const alignObjects = ({ commit, dispatch, state }, { align }) => {
  const {
    width: groupWidth,
    height: groupHeight,
    left: groupLeft,
    top: groupTop,
    type,
    _objects,
    $$uid,
  } = $XJCanvas.getActiveObject();
  // group
  if (type === 'activeSelection') {
    _objects.forEach(obj => {
      const uid = obj.$$uid;
      const itemWidth = obj.width;
      const itemHeight = obj.height;
      let left;
      let top;
      let objectLeft = 0;
      let objectTop = 0;
      let originX = 'left';
      let originY = 'top';
      switch (align) {
        case 'left':
          left = -(groupWidth / 2);
          originX = 'left';
          // 相对于canvas的left
          objectLeft = groupLeft;
          break;
        case 'centerH':
          left = -itemWidth / 2;
          originX = 'left';
          // 相对于canvas的left
          objectLeft = groupLeft + (groupWidth - itemWidth) / 2;
          break;
        case 'right':
          //
          left = groupWidth / 2 - itemWidth;
          originX = 'left';
          // 相对于canvas的left
          objectLeft = groupLeft + (groupWidth - itemWidth);
          break;
        case 'top':
          top = -(groupHeight / 2);
          originY = 'top';
          // 相对于canvas的left
          objectTop = groupTop;
          break;
        case 'centerV':
          top = -itemHeight / 2;
          originY = 'top';
          // 相对于canvas的left
          objectTop = groupTop + (groupHeight - itemHeight) / 2;
          break;
        case 'bottom':
          top = groupHeight / 2 - itemHeight;
          originX = 'top';
          // 相对于canvas的left
          objectTop = groupTop + (groupHeight - itemHeight);
          break;
      }

      if (left !== undefined) {
        obj.set({ left, originX });
        obj.setCoords();
        commit('UPDATE_OBJECT_PROPS', {
          uid,
          props: { left: objectLeft, originX },
        });
      } else if (top !== undefined) {
        obj.set({ top, originY });
        obj.setCoords();
        commit('UPDATE_OBJECT_PROPS', {
          uid,
          props: { top: objectTop, originY },
        });
      }
    });
  } else if (type === 'textbox') {
    state.objectMap[$$uid].set({ textAlign: align });
    commit('UPDATE_OBJECT_PROPS', { uid: $$uid, props: { textAlign: align } });
  }
  $XJCanvas.requestRenderAll();
  dispatch('record/addState', getRecordState(state), { root: true });
};

// 一个记录点
export const addNewText = (context, { t }) => {
  const { commit, state, dispatch } = context;
  commit('INCREASE_UID');
  const uid = state.uid;
  const { left = 0, top = 0 } = state.cropInfoTemp;
  const props = {
    fontSize: 28,
    source: '',
    target: t('propsEditor.dblclickToAddText'),
    width: 58,
    height: 32,
    lineHeight: 1,
    left: 28 + left,
    top: 28 + top,
    angle: 0,
    fg: '#ffffff',
    fontFamily: '',
    strokeWidth: 0,
    stroke: 'transparent',
    paintFirst: 'stroke',
    fgType: 'pure',
    fgGradientDirection: 'v',
    fgGradientStart: '#ffffff',
    fgGradientEnd: '#ffffff',
  };
  const text = new fabric.Textbox(props.target, normalizeObjectPropsFromPropsEditor(props));
  text.$$uid = uid;
  setTextObject({ text, uid, commit, context });

  commit('ADD_OBJECT', { uid, object: text, props });
  $XJCanvas.add(text);
  $XJCanvas.setActiveObject(text);

  dispatch('record/addState', getRecordState(state), { root: true });
  scroll2object(text);
};

export const setPasteText = context => {
  const { state, commit, dispatch } = context;
  const copyText = state.objectPropsMap[state.copyUID];
  if (state.copyUID === '' || !copyText) return;
  const { $$fabricObjectType, ...props } = copyText;
  // 设置偏移
  Object.assign(props, {
    left: props.left + 5,
    top: props.top + 5,
  });
  console.log(8888888888, props);
  const options = normalizeObjectPropsFromPropsEditor(props);
  const text = new fabric.Textbox(options.text, options);
  commit('INCREASE_UID');
  const { uid } = state;
  text.$$uid = uid;
  setTextObject({ text, uid, commit, context });
  commit('ADD_OBJECT', { uid, object: text, props });
  $XJCanvas.add(text);
  $XJCanvas.setActiveObject(text);

  dispatch('record/addState', getRecordState(state), { root: true });
};

export const setPasteRect = context => {
  const { state, commit, dispatch } = context;
  const copyRect = state.objectPropsMap[state.copyUID];
  if (state.copyUID === '' || !copyRect) return;
  const { $$fabricObjectType, ...props } = copyRect;
  // 设置偏移
  Object.assign(props, {
    left: props.left + 5,
    top: props.top + 5,
  });
  const options = normalizeObjectPropsFromPropsEditor(props);
  console.log(8888888888, options);

  const rect = new fabric.Rect({ ...options });
  commit('INCREASE_UID');
  const { uid } = state;
  rect.$$uid = uid;
  setRectObject({ object: rect, uid, commit, state, context });
  commit('ADD_OBJECT', { uid, object: rect, props });
  $XJCanvas.add(rect);
  $XJCanvas.setActiveObject(rect);

  dispatch('record/addState', getRecordState(state), { root: true });
};

export const addNewBrushPath = ({ state, commit, dispatch }) => {
  if (state.isDraw2CancelTransMode || state.isAiInpaintMode) return;
  commit('INCREASE_UID');
  const uid = state.uid;
  const objects = $XJCanvas.getObjects();
  const pathObject = objects[objects.length - 1];
  pathObject.$$uid = uid;
  setPathProps({ commit, state, object: pathObject, uid });
  commit('ADD_OBJECT', { uid, object: pathObject, props: pathObject.toJSON() });
  movedownPathLayer({ commit, state, object: pathObject });
  dispatch('record/addState', getRecordState(state), { root: true });
};

export const addNewRect = context => {
  const { state, commit, dispatch, getters } = context;
  commit('INCREASE_UID');
  const uid = state.uid;
  const { left, top } = state.cropInfoTemp;
  const croppedCanvasWidth = getters['croppedCanvasWidth'];
  const croppedCanvasHeight = getters['croppedCanvasHeight'];
  const width = croppedCanvasWidth > 100 ? 100 : croppedCanvasWidth;
  const height = croppedCanvasHeight > 58 ? 58 : croppedCanvasHeight;
  const rect = new fabric.Rect({
    left: (croppedCanvasWidth - width) / 2 + left,
    top: (croppedCanvasHeight - height) / 2 + top,
    width,
    height,
    fill: '#f00',
    stroke: '',
    strokeWidth: 0,
  });
  rect.$$uid = uid;
  $XJCanvas.add(rect);
  $XJCanvas.setActiveObject(rect);
  setRectObject({ object: rect, uid, commit, state, context });
  commit('ADD_OBJECT', { uid, object: rect, props: rect.toJSON() });
  movedownPathLayer({ commit, state, object: rect });
  dispatch('record/addState', getRecordState(state), { root: true });
  scroll2object(rect);
};

export const cancelTranslate = (context, payload) => {
  const { state, commit, dispatch, getters } = context;
  const {
    left: $left,
    top: $top,
    width: $width,
    height: $height,
    originLeft,
    originTop,
    originWidth,
    originHeight,
  } = payload.props;
  // 如果存在原图几个位置信息，就用原图的，否则使用译图位置信息
  const left = originLeft || $left;
  const top = originTop || $top;
  const width = originWidth || $width;
  const height = originHeight || $height;

  const textUID = payload.uid;
  fabric.Image.fromURL(
    state.OriginUrl,
    object => {
      object.set({ left, top, width, height, cropX: left, cropY: top, lockRotation: true });

      commit('INCREASE_UID');
      const { uid } = state;
      console.log({ object, left, top, width, height, object });
      object.$$uid = uid;
      object.$$isCancelTranslated = 1;
      commit('ADD_OBJECT', {
        uid,
        object,
        props: { ...object.toJSON(), $$translatedProps: getters['selectedObjectProps'] },
      });
      $XJCanvas.add(object);
      setImageObject({ object, uid, commit, state, context });
      const insertIdx = state.objectUIDs.indexOf(textUID);
      object.moveTo(insertIdx + 1);
      const selectedObject = $XJCanvas.getActiveObject();
      $XJCanvas.remove(selectedObject);
      commit('REMOVE_SELECTED_OBJECT');
      $XJCanvas.setActiveObject(object);
      commit('SET_SELECTED_OBJECT_UID', uid);
      setCurrentPropsEditorType({ commit }, 'image');
      $XJCanvas.requestRenderAll();
      dispatch(
        'record/addState',
        {
          objectPropsMap: state.objectPropsMap,
          objectUIDs: state.objectUIDs,
          RmUrl: state.RmUrl,
          OriginUrl: state.OriginUrl,
        },
        { root: true }
      );
    },
    {
      crossOrigin: 'anonymous',
      // objectCaching: true,
    }
  );
};

export const cancelTranslateByDrawing = (context, payload) => {
  const { state, commit, dispatch } = context;
  const { canvasWidth, canvasHeight } = state.editorSize || {};
  // $XJCanvas.freeDrawingBrush.color = 'transparent';
  $XJCanvas.on('path:created', function (opt) {
    if (!state.isDraw2CancelTransMode) return;
    console.log(111111, opt.path, opt.path.toDataURL());
    const { path } = opt;
    path.set({
      stroke: 'red', // 描边颜色透明
      fill: 'red', // 填充颜色透明
      absolutePositioned: true, // 确保剪切区域正确定位
    });
    // 创建一个新的路径组，将所有路径叠加在一起
    const clipPathGroup = new fabric.Group([path], {
      originX: 'left',
      originY: 'top',
      absolutePositioned: true, // 确保位置正确
    });
    // 移除之前的绘制路径
    $XJCanvas.remove(path);
    fabric.Image.fromURL(
      state.OriginUrl,
      object => {
        commit('INCREASE_UID');
        const { uid } = state;
        object.set({
          left: 0,
          top: 0,
          width: canvasWidth,
          height: canvasHeight,
          lockRotation: true,
          selectable: false,
          $$uid: uid,
          clipPath: clipPathGroup,
          dirty: true,
          event: false,
          hoverCursor: 'default',
        });

        // let clipPath = object.clipPath;
        // fabric.util.enlivenObjects([object.clipPath], function (arg1) {
        //   clipPath = arg1[0];
        // });
        commit('ADD_OBJECT', {
          uid,
          object: object,
          props: {
            ...object.toObject(),
            selectable: false,
            lockRotation: true,
            event: false,
            $$isDraw2CancelTranslated: 1,
            hoverCursor: 'default',
          },
        });
        $XJCanvas.add(object);
        $XJCanvas.renderAll();
        object.moveTo(0);
        commit(
          'SET_objectUIDs',
          $XJCanvas.getObjects().map(i => i.$$uid)
        );
        // 渲染画布
        dispatch(
          'record/addState',
          {
            objectPropsMap: state.objectPropsMap,
            objectUIDs: state.objectUIDs,
            RmUrl: state.RmUrl,
            OriginUrl: state.OriginUrl,
          },
          { root: true }
        );
      },
      { crossOrigin: 'anonymous' }
    );
  });
};

// 智能消除笔
export const doAiInpainting = (context, payload = {}) => {
  const { $t } = payload;
  const { state, commit, dispatch } = context;
  const { canvasWidth, canvasHeight } = state.editorSize || {};
  // $XJCanvas.freeDrawingBrush.color = 'transparent';
  $XJCanvas.on('path:created', function (opt) {
    if (!state.isAiInpaintMode) return;
    console.log(111111, opt.path, opt.path.toDataURL());
    const { path } = opt;
    path.set({
      stroke: 'white', // 描边颜色透明
      fill: 'white', // 填充颜色透明
      absolutePositioned: true, // 确保剪切区域正确定位
    });

    // 创建一个临时的离屏 canvas
    const offscreenCanvas = document.createElement('canvas');
    offscreenCanvas.width = canvasWidth;
    offscreenCanvas.height = canvasHeight;
    // 将 path 绘制到离屏 canvas
    const tempCanvas = new fabric.StaticCanvas(offscreenCanvas, { backgroundColor: 'transparent' });
    tempCanvas.add(path);
    tempCanvas.renderAll();

    // 移除之前的绘制路径
    $XJCanvas.remove(path);

    function fn({ image }) {
      commit('SET_INPAINTING', true);
      apis.app
        .imagePainting({
          requestId: context.rootState.multi.requestId,
          image,
          mask: tempCanvas.toDataURL(),
        })
        .then(image => {
          console.log('doAiInpainting res', image);
          commit('SET_STATE', { RmUrl: image });
          dispatch('record/addState', getRecordState(state), { root: true });
        })
        .catch(() => {
          message.error($t('common.aieraserError'));
        })
        .finally(() => {
          commit('SET_INPAINTING', false);
        });
    }

    if (isBase64(state.RmUrl)) {
      fn({ image: state.RmUrl });
    } else {
      fabric.Image.fromURL(
        state.RmUrl,
        object => {
          fn({ image: object.toDataURL() });
        },
        { crossOrigin: 'anonymous' }
      );
    }
  });
};

export const retranslate = (context, payload) => {
  const { state, commit, dispatch } = context;
  const { $$translatedProps } = payload.props;
  const imgUID = payload.props.$$uid;
  console.log($$translatedProps);
  // 移除当前图片
  const selectedObject = $XJCanvas.getActiveObject();
  $XJCanvas.remove(selectedObject);
  commit('REMOVE_SELECTED_OBJECT');

  // 创建文本
  const text = new fabric.Textbox($$translatedProps.target, normalizeObjectPropsFromPropsEditor($$translatedProps));
  commit('INCREASE_UID');
  const { uid } = state;
  text.$$uid = uid;
  setTextObject({ text, uid, commit, context });
  const insertIdx = state.objectUIDs.indexOf(imgUID);
  text.moveTo(insertIdx + 1);
  commit('ADD_OBJECT', { uid, object: text, props: $$translatedProps });
  $XJCanvas.add(text);
  $XJCanvas.setActiveObject(text);
  commit('SET_SELECTED_OBJECT_UID', uid);
  $XJCanvas.requestRenderAll();
  dispatch('record/addState', getRecordState(state), { root: true });
};

// 只删除所有object，不删除背景，也不重复绑定canvas事件
export const renderAll = async (context, payload) => {
  const objects = $XJCanvas.getObjects();
  $XJCanvas.remove(...objects);
  const { commit, state } = context;
  const { manualSortedUids } = state;
  const { objectUIDs, cropInfo, objectPropsMap, shouldAdjustFontSize } = payload;
  const objectMap = {};
  const asyncArr = objectUIDs.map((uid, idx) => {
    const { $$fabricObjectType, ...restOptions } = objectPropsMap[uid];
    let isAsync = false;
    let object = null;
    return () =>
      new Promise(resolve => {
        try {
          if ($$fabricObjectType === 'path') {
            console.log('renderAll path props', restOptions, $$fabricObjectType);
            object = new fabric.Path(restOptions.path, restOptions);
            setPathProps({ commit, state, object, uid });
            object.$$uid = uid;
          } else if ($$fabricObjectType === 'rect') {
            object = new fabric.Rect(restOptions);
            setRectObject({ commit, state, object, uid, context });
            object.$$uid = uid;
          } else if ($$fabricObjectType === 'image') {
            console.log('image', idx, { restOptions });
            isAsync = true;
            fabric.Image.fromURL(
              state.OriginUrl,
              img => {
                object = img;
                // 如果是draw2cancel的图片，不需要设置事件
                if (restOptions.$$isDraw2CancelTranslated) {
                  object.hoverCursor = 'default';
                } else {
                  setImageObject({ object, uid, commit, state, context });
                }
                object.$$uid = uid;
                object.set(restOptions);
                if (restOptions.clipPath) {
                  fabric.util.enlivenObjects([restOptions.clipPath], function (arg1) {
                    object.clipPath = arg1[0];
                  });
                }
                if (manualSortedUids.indexOf(+uid) > -1) {
                  object.$$manualSorted = 1;
                }
                console.log('renderAll object added', object);
                objectMap[uid] = object;
                $XJCanvas.add(object);
                resolve(object);
              },
              { crossOrigin: 'anonymous' }
            );
            // setRectObject({ commit, state, object, uid, context });
          } else {
            const options = normalizeObjectPropsFromPropsEditor(restOptions);
            object = new fabric.Textbox(options.text, options);
            // 仅仅首次渲染的时候需要自动调节字体
            if (shouldAdjustFontSize) {
              adjustFontSize({ uid, object, options, objectPropsMap });
            }
            // 给text object增加一个uid
            object.$$uid = uid;
            setTextObject({ text: object, uid, commit, context });
          }
          if (object && !isAsync) {
            if (manualSortedUids.indexOf(+uid) > -1) {
              object.$$manualSorted = 1;
            }
            console.log('renderAll object added', object);
            objectMap[uid] = object;
            $XJCanvas.add(object);
            resolve(object);
          }
        } catch (err) {
          console.error(uid, err);
        }
      });
  });

  // 按照顺序执行异步函数
  for (let i = 0, l = asyncArr.length; i < l; i++) {
    await asyncArr[i]();
  }
  commit('RENDER_ALL', { objectUIDs, cropInfo, objectPropsMap, objectMap });
  commit('SET_IS_UNDO_REDO_RENDERING', false);
};

export const firstRender = async (context, payload) => {
  const { FROM_STORAGE, ...restPayload } = payload;
  // 从storage中获取的数据就不要调整字号了，之前已经调整过了
  await renderAll(context, { ...restPayload, shouldAdjustFontSize: FROM_STORAGE ? false : true });
  context.commit('SET_READY');
  context.dispatch(
    'record/addState',
    {
      ...cloneDeep(restPayload),
      $IS_FIRST: true,
      RmUrl: context.state.RmUrl,
      OriginUrl: context.state.OriginUrl,
    },
    { root: true }
  );
  setTopOneActive(context);
};

export const setTopOneActive = ({ state, commit }) => {
  const topOneUid = findTopText(state.objectPropsMap)[0]?.uid;
  if (topOneUid > -1) {
    const activeOne = $XJCanvas.getObjects().filter(i => +i.$$uid === +topOneUid)[0];
    $XJCanvas.setActiveObject(activeOne);
    // console.log(11111, topOneUid, activeOne);
    commit('SET_SELECTED_OBJECT_UID', +topOneUid);
    $XJCanvas.renderAll();
  }
};

function movedownPathLayer({ commit, state, object }) {
  const { objectUIDs, objectMap } = state;
  const list = objectUIDs.map(i => {
    const o = objectMap[i];
    return { uid: i, type: o?.type, $$manualSorted: o.$$manualSorted };
  });
  let insertIdx = findLastIndex(list, i => {
    // 筛选出最后一个path且不是本条path且没有经过手动排序过的
    return (i.type === 'path' || i.type === 'rect') && i.uid !== object.$$uid && !i.$$manualSorted;
  });
  console.log('-------------', list, insertIdx);
  object.moveTo(insertIdx + 1);
  commit(
    'SET_objectUIDs',
    $XJCanvas.getObjects().map(i => i.$$uid)
  );
  $XJCanvas.renderAll();
}

function setPathProps({ commit, state, object, uid }) {
  object.selectable = false;
  object.hoverCursor = 'default';
  // 避免选不中下面元素
  object.evented = false;
  object.hasControls = false;
  // object.on('selected', e => {
  //   commit('SET_SELECTED_OBJECT_UID', uid);
  //   if (!state.isGrouping) {
  //     setCurrentPropsEditorType({ commit }, 'path');
  //   }
  // });
}

function setRectObject({ object, uid, commit, state, context }) {
  object.on('mousedown', e => {
    commit('SET_SELECTED_OBJECT_UID', uid);
    if (!state.isGrouping) {
      setCurrentPropsEditorType({ commit }, 'rect');
    }
  });
  object.on('modified', function (e) {
    // canvas向store绑定
    const { width, height, left, top, fill, angle, scaleX, scaleY } = e.target;
    // console.log(1111111, e, { width, height, left, top, fill, angle, scaleX, scaleY });
    updateSelectedObjectFromCanvas(context, { width, height, left, top, fill, angle, scaleX, scaleY });
  });
}

function setTextObject({ text, uid, commit, context }) {
  // 不显示上下拉升（文字会变形）
  text.setControlVisible('mb', false);
  text.setControlVisible('mt', false);
  text.on('selected', e => {
    commit('SET_SELECTED_OBJECT_UID', uid);
    if (!context.state.isGrouping) {
      setCurrentPropsEditorType({ commit }, 'textbox');
    }
  });
  text.on('changed', function (e) {
    console.log('changed', text.text, e);
    // canvas向store绑定
    updateSelectedObjectFromCanvas(context, {
      target: text.text,
    });
  });
  text.on('mouseover', function () {
    if (context.state.selectedObjectUid === this.$$uid) return;
    this._renderControls(this.canvas.contextTop, {
      hasControls: false,
    });
  });
  text.on('mousedown', function () {
    this.canvas.contextTop && this.canvas.clearContext(this.canvas.contextTop);
  });
  text.on('mouseout', function () {
    this.canvas.contextTop && this.canvas.clearContext(this.canvas.contextTop);
  });
  text.on('modified', e => {
    if (!e.target) return;
    const { left, top, width, height, angle, scaleX, fontSize } = e.target;
    const nextFontSize = fontSize * scaleX;
    const nextWidth = width * scaleX;
    console.log(1122222221, fontSize, scaleX, nextFontSize);
    updateSelectedObjectFromCanvas(context, {
      left: Math.ceil(left),
      top: Math.ceil(top),
      width: Math.ceil(nextWidth),
      height: Math.ceil(height),
      angle: Math.ceil(angle),
      scaleX: 1,
      scaleY: 1,
      fontSize: nextFontSize,
    });
  });
}

export const setSpaceBarPressed = ({ commit }, payload) => {
  commit('SET_SPACEBAR_PRESSED', payload);
};

export const setCanvasScale = ({ commit }, payload) => {
  commit('SET_CANVAS_SCALE', payload);
  scroll2object($XJCanvas.getActiveObject());
};
export const setCanvasGrabing = ({ commit }, payload) => {
  commit('SET_CANVAS_GRABING', payload);
};

// 自动调整字体大小
function adjustFontSize({ uid, object, options, objectPropsMap, lastInfo = {}, adjustType = '' }) {
  let { height, fontSize, text, orientation, TargetLanguage, lineCount } = options;
  object.set('$adjustfscount', (object.get('$adjustfscount') || 0) + 1);
  const isJCK = isJCKLanguage(TargetLanguage);
  console.log({ lineCount });
  // 只有中日韩方块字的垂直才是真正的垂直，其他的现在的处理是水平旋转90度，所以不算是垂直
  const isV = orientation === 'v' && isJCK;
  let shouldAdjust = false;
  let currentInfo = { fontSize };
  const scaleRatio = 0.9;

  // 垂直文本的自调节条件
  if (isV) {
    // return;
    const realHeight = object.getScaledHeight();
    currentInfo.height = realHeight;
    if (height) {
      if (realHeight > height) {
        shouldAdjust = true;
        adjustType = 'smaller';
      }
      // 首次进来就发现比实际渲染比预期小很多，则放大
      else if (realHeight / height < scaleRatio && adjustType !== 'smaller') {
        adjustType = 'larger';
        shouldAdjust = true;
      }
    }
    // shouldAdjust = false;
    // console.log('1=>', { height, realHeight, text, adjustType });
  }
  // 水平文本的自调节条件
  else {
    // 211117:渲染出来的高度是接口返回的高度1.5倍的话，就递归缩小字体，直到高度没差那么大
    // 211118:改用行数判断，如果超过1行就缩小字号，如果将来图片翻译支持返回多行文本，则问下是否能返回行数，这样用来跟实际渲染出来的行数做对比
    const { textLines } = object;
    shouldAdjust = height && textLines.length > lineCount;
    // console.log('1=>', { text, fontSize, height, textLines });
  }

  // 实际渲染情况，还没有把属性值同步到store里
  if (shouldAdjust) {
    const newFs = adjustType === 'larger' ? fontSize / scaleRatio : fontSize * scaleRatio;
    const newOptions = { ...options, fontSize: newFs };
    object.set(newOptions);
    // console.log('2readjust', object.top);
    // 避免死循环
    if (object.get('$adjustfscount') <= 108) {
      adjustFontSize({ uid, object, options: newOptions, objectPropsMap, lastInfo: currentInfo, adjustType });
    } else {
      return;
    }
  }
  // 把实际渲染用到的props同步回objectPropsMap中
  else {
    // 垂直文本直接使用上一次调节的
    if (isV) {
      fontSize = lastInfo.fontSize || fontSize;
      const newOptions = { ...options, fontSize };
      object.set(newOptions);
    }
    const originalObjectProps = objectPropsMap[uid];
    // 字体大小纠正后需要重新计算下shadow（跟字号有关）
    const shadow = getShadow({ ...originalObjectProps, fontSize });
    // 一通调节之后需要重新计算出高度
    const realHeight = object.getScaledHeight();

    let { top, height } = originalObjectProps;
    top += (height - realHeight) / 2;
    top = top > 0 ? top : 0;
    Object.assign(originalObjectProps, { fontSize, height: realHeight, top });
    object.set({ shadow, top });
    // console.log('3ok', object.top);
    return;
  }
}

export const manualSelectObject = ({ commit }, uid) => {
  const object = $XJCanvas.getObjects().filter(i => i.$$uid === uid)[0];
  if (object) {
    commit('SET_SELECTED_OBJECT_UID', uid);
    $XJCanvas.setActiveObject(object);
    $XJCanvas.renderAll();
  }
};

export const setInpaintedBg = ({ dispatch, state }) => {
  const payload = {
    objectPropsMap: state.objectPropsMap,
    objectUIDs: state.objectUIDs,
    RmUrl: state.RmUrl,
    OriginUrl: state.OriginUrl,
  };
  dispatch('record/addState', payload, { root: true });
  console.log('record');
};
